import { useEffect } from 'react';
import { useStore } from 'providers';
import { usePageTitle, useFetchFromService } from 'hooks';
import { Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import Loader from 'components/Loader';
import UserDetailsCard from 'components/UserDetailsCard';
import UserProfileCard from 'components/UserProfileCard';
import BalanceCard from 'components/BalanceCard';
import { referAndEarnNotification } from 'constants/availableNotifications';
import { pushAnalyticsEvent } from 'helpers/analytics';

import {
  StyledLayout,
  PageHeader,
  PageTitle,
  StyledContainer,
  StyledButton,
  SettingsCog,
  StyledNotificationCentre,
  StyledGrid,
} from './Profile.styles';

const pageTitle = 'Profile';

function Profile() {
  usePageTitle(pageTitle);

  const { store } = useStore();
  const { userData, loyaltyData } = store;

  const fetchLoyaltyData = useFetchFromService('loyaltyData');

  useEffect(() => {
    if (!loyaltyData) {
      fetchLoyaltyData();
    }
  }, [loyaltyData, fetchLoyaltyData]);

  const referAndEarn = {
    ...referAndEarnNotification,
    title: 'Refer and Earn',
    onClick: () => pushAnalyticsEvent({ event: 'clickReferAFriend', title: 'Profile Page' }),
  };

  return (
    <StyledLayout ariaLabel="Profile page">
      {loyaltyData && userData ? (
        <StyledContainer>
          <PageHeader>
            <PageTitle variant="h1">Your Profile</PageTitle>
            <StyledButton aria-label="Edit profile" component={Link} to={ROUTES.PROFILE_EDIT}>
              <SettingsCog />
            </StyledButton>
          </PageHeader>

          <Grid container spacing={2}>
            <Grid item xs={12} lg={6} order={{ lg: 2 }}>
              <UserProfileCard userData={userData} />
            </Grid>

            <StyledGrid item xs={12} order={{ lg: 1 }}>
              <BalanceCard points={userData?.pointsDetails?.points} pageTitle={pageTitle} />
            </StyledGrid>

            <StyledGrid item xs={12} lg={6} order={{ lg: 3 }}>
              <UserDetailsCard loyaltyData={loyaltyData} userData={userData} />
            </StyledGrid>

            <Grid item xs={12} order={{ lg: 4 }}>
              <StyledNotificationCentre items={[referAndEarn]} />
            </Grid>
          </Grid>
        </StyledContainer>
      ) : (
        <Loader color="light" />
      )}
    </StyledLayout>
  );
}

export default Profile;
